import { useCartContext } from "app/providers/CartProvider";
import { useEffect } from "react";
import CheckoutOverviewFooter from "widgets/checkout/overview-footer";
import CheckoutProducts from "widgets/checkout/overview-products";
import CheckoutWarranty from "widgets/checkout/warranty";

const CheckoutSampleSaleDoorOverview = () => {
  const cart = useCartContext().cart;

  return (
    <>
      <CheckoutProducts />

      <CheckoutOverviewFooter />
    </>
  );
};
export default CheckoutSampleSaleDoorOverview;
